import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";

import NibbleInput from "../../../components/Fields/NibbleInput";
import { postUserSendPin, postUserVerifyPin } from "../../../helpers/backend_helper";

const ValidatePhone = ({ user, setUser }) => {
  const [pinSent, setPinSent] = useState("");
  const [validatingPin, setValidatingPin] = useState("");
  const [modal, setModal] = useState({
    show: false,
  });
  const [isSendingPing, setIsSendingPin] = useState(false);

  const isValidNumber = String(user?.phone).length == 10;

  const onSubmit = async (formValues) => {
    try {
      setValidatingPin(true)
      const response = await verifyPin(user.phone, validation.values.pin)

      console.log("PIN verification response:", response);

      if (response) {
        setUser((prev) => ({
          ...prev,
          phone_validated: 1,
        }));
        modalToggle();
      }
    } catch (error) {
      console.error("Error validating phone:", error);
    }
    setValidatingPin(false)
  };

  const validation = useFormik({
    initialValues: {
      pin: "",
    },
    validationSchema: Yup.object({
      pin: Yup.string().required().label("PIN"),
    }),
    onSubmit,
  });

  const modalToggle = () => {
    setModal({ show: !modal.show });
  };

  const sendPin = () => {
    setIsSendingPin(true);


    postUserSendPin({ phone: user.phone })
      .finally(() => {
        setIsSendingPin(false);
      });
  };

  const verifyPin = async (phone, pin) => {
    try {
      const response = await postUserVerifyPin({
        phone: user.phone,
        pin
      });
      console.log("Received response from verifyPin:", response);
      // post() ahora devuelve un sentinel {status:false,...} en vez de `false`,
      // asi que hay que mirar `status` o un PIN invalido se daria por bueno.
      if (!response || response.status === false)
        return false;

      return true;
    } catch (error) {
      console.error("Error verifying PIN:", error);
    }
    return false;
  }

  return (
    <>
      {user.phone_validated ? (
        <div className="input-group-text bg-white">
          <i
            title="Teléfono validado"
            className="fas fa-check-circle text-success"
          ></i>
        </div>
      ) : (
        <div
          className="input-group-text bg-white"
          style={{ cursor: isValidNumber ? "pointer" : "not-allowed" }}
          role="button"
          onClick={() => {
            if (!isValidNumber) return;

            validation.resetForm();
            modalToggle();
            sendPin();
          }}
          title="Validar por Whats App"
        >
          <i
            title="Validar teléfono"
            className={`fab fa-whatsapp ${isValidNumber && "text-success"}`}
          ></i>
        </div>
      )}
      {modal.show && (
        <Modal isOpen={modal.show}>
          <Form
            onSubmit={(e) => {
              console.log("Submitting form with values:", validation.values);
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <ModalHeader className="bg-primary">
              Ingresa el PIN enviado por WhatsApp
            </ModalHeader>
            <ModalBody>
              {isSendingPing ? (
                <div className="text-center">
                  <Spinner size="sm" />
                  <p>Enviando PIN</p>
                </div>
              ) : (
                <Row className="justify-content-center align-content-center">
                  <NibbleInput
                    md={6}
                    label="PIN:"
                    fieldName="pin"
                    fieldType="text"
                    validation={validation}
                  />
                </Row>

              )}
            </ModalBody>
            <ModalFooter>
              <Button
                color="primary"
                type="button"
                disabled={isSendingPing}
                onClick={() => validation.handleSubmit()}
              >
                {validatingPin ? (
                  <>
                    <Spinner size="sm" />
                  </>
                ) : (
                  <>
                    <i className="fa fa-save"></i> Guardar
                  </>
                )}
              </Button>{" "}
              <Button
                type="button"
                color="secondary"
                onClick={modalToggle}
                disabled={isSendingPing}
              >
                <i className="fa fa-times"></i> Cancelar
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default ValidatePhone;
